<template>
    <div style="width: 100%; margin: 0 auto; background: #f5f5f5; margin-top: 0.7rem;position: relative;">
        <div class="container" v-if="!props_.type">
            <div style="display: flex; align-items: center;column-gap: 12px;">
                <div style=" font-weight: 400; color: #333333; font-size: 28px;">
                    <span>全部作品</span>
                </div>
                <div style="  font-weight: 700; color: #333333; font-size: 28px;">
                    <span>{{ queryParams.total }}</span>
                </div>
            </div>
            <el-empty description="暂无数据" v-if="!list.length && !loading" />
            <div class="" v-if="list.length"
                style="display: flex; align-items: center;column-gap: 15px;flex-wrap: wrap;width: 100%;margin-top: 24px;row-gap: 15px;margin-top: 8px;">
                <div style="width: 24%;" @click="btn(item)" v-for=" item  in list" :key="item.id">
                    <div style="width: 100%;height: 180px;border-radius: 10px;flex: none;position: relative;">
                        <img style="width: 100%;height: 180px;border-radius: 12px;object-fit:cover;"
                            :src="item.materialType == 'IMAGE' ? item.imagesOther ? JSON.parse(item.imagesOther)[0].url : '' : item.showImage"
                            alt="" sizes="" srcset="">
                        <div style="position: absolute;bottom: 20px;left: 0;width: 100%;" v-if="activityType == '4'">
                            <div
                                style="display: flex;align-items: center;justify-content: space-between;color: #FFF;padding: 0 10px;">
                                <div>
                                    <img v-if="item.materialType == 'VIDEO'"
                                        style="width: 20px;height:20px;vertical-align: middle;"
                                        src="../../assets/index_bfl.png" />
                                    <el-icon v-else style="font-size: 15px;vertical-align: middle;">
                                        <Picture />
                                    </el-icon>
                                    <span style="margin-left: 8px;">{{ item.playCount
                                    }}</span>
                                </div>
                                <div v-if="voteSwitch">
                                    <img v-if="item.voteFlag" style="width: 13px;height: 14px;cursor: pointer;"
                                        src="../../assets/98.png" />
                                    <img @click.stop="voteBtn_(item)" v-else
                                        style="width: 13px;height: 14px;cursor: pointer;" src="../../assets/99.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style=" color: #333333; font-size: 16px; font-weight: 400;margin-top: 8px;height: 40px;">
                        <span>{{ activityType == '4' ? item.fineFileTitle ? item.fineFileTitle : item.materialType ==
                            'IMAGE' ?
                            item.imagesOther ? JSON.parse(item.imagesOther)[0].title : '' : item.title : item.title
                        }}</span>
                    </div>
                </div>
            </div>
            <div v-if="list.length"
                style="padding-bottom: 20px;padding-top: 20px; display: flex;justify-content: flex-end;align-items: center;width: 100%;">
                <el-pagination :total="queryParams.total" :current-page="queryParams.pageNum"
                    @current-change="paginationChange" :page-size="queryParams.pageSize" />
            </div>
        </div>
        <el-dialog v-model="isShowShare" modal-class="allProduction" :destroy-on-close="true" :show-close="false"
            :close-on-click-modal="false" width="800">
            <template #header>
                <div
                    style="display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid rgb(238, 238, 238);padding-bottom: 10px;">
                    <div style="display: flex;align-items: center;column-gap: 10px;">
                        <div style="width: 40px;height: 40px;" @click="toUser">
                            <img :src="userInfo.avatar ? userInfo.avatar : require('../../assets/logo.png')" alt=""
                                style="width: 100%;height: 100%;border-radius: 50%;" srcset="">
                        </div>
                        <div style="font-size: 14px;">
                            <span style="margin-right: 5px;">{{ userInfo.nickName }}</span>
                            <img style="height: 0.16rem;vertical-align: middle;margin-top: -2px;"
                                v-if="userInfo.realStatus == 2" @click="CertificationCenter" src="@/assets/Frame1.png"
                                title="实名认证" />
                            <img style="height: 0.16rem;vertical-align: middle;margin-top: -2px;"
                                v-if="userInfo.enterpriseStatus == 2" @click="CertificationCenter" src="@/assets/Frame2.png"
                                title="企业认证" />
                            <img style="height: 0.16rem;vertical-align: middle;margin-top: -2px;"
                                v-if="userInfo.unionStatus == 2" @click="CertificationCenter" src="@/assets/Frame3.png"
                                title="联盟认证" />
                            <div v-if="userInfo.professionalStatus == 2"
                                style="display: flex;justify-content: center;padding: 0.1rem 0;">
                                <div class="wVC_list_l_T_B_rz">
                                    <img src="@/assets/bvlv_blue.png" />
                                    标识山西认证{{ userInfo.profess }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="font-size: 18px;cursor: pointer;display: flex;align-items: center;column-gap: 15px;">
                        <div style="" v-if="activityType == '4' && login_info.memberId != userInfo.memberId">
                            <div v-if="ids.includes(userInfo.memberId)" class="BU_gz"
                                style="color: #fff;background: #86909c;border: 0.01rem solid #86909c;"
                                @click="handleDelete">已关注
                            </div>
                            <div class="BU_gz" @click="handleAdd" v-else>关注</div>
                        </div>
                        <!-- getList('a'), isShowShare = false -->
                        <el-icon @click="closeBtn">
                            <CircleCloseFilled />
                        </el-icon>
                    </div>
                </div>

            </template>
            <div class="body_left_video"
                v-if="activityType == '4' && info__.materialType != 'IMAGE' || activityType == '2' && info__.type != 'img' || props_.type == 'no' && info__.materialType != 'IMAGE'">
                <video-player id="allProduction" class="custom-video-player" ref="videoPlayer"
                    :options="playerOptions"></video-player>
            </div>
            <div v-else>
                <el-image v-if="activityType == '2'" style="width: 100%; height: 400px;border-radius:12px;" :zoom-rate="1.2"
                    :max-scale="7" :min-scale="0.2" :preview-src-list="[info__.showImage]" :src="info__.showImage"
                    fit="scale-down" />
                <div v-else>
                    <el-carousel height="400px">
                        <el-carousel-item v-for="imgs_ in JSON.parse(info__.imagesOther)" :key="imgs_.title">
                            <el-image style="width: 100%; height: 400px;border-radius:12px;" :zoom-rate="1.2" :max-scale="7"
                                :min-scale="0.2" :src="imgs_.url" fit="scale-down" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div :style="[{ color: '#000', fontSize: '20px', letterSpacing: '1px', marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, { borderBottom: !info__.content ? '1px solid #FFF' : '1px solid rgb(238, 238, 238)' }, {
                paddingBottom:
                    !info__.content ? '0px' : '10px'
            }]">
                <div> <span>{{ activityType == '4' ? info__.fineFileTitle ? info__.fineFileTitle : info__.materialType ==
                    'IMAGE' ?
                    info__.imagesOther ? JSON.parse(info__.imagesOther)[0].title : '' : info__.title : info__.title
                }}</span></div>
                <div v-if="activityType == '4' && voteSwitch" style="display: flex;align-items: center;column-gap: 15px;">
                    <div><el-button @click="voteBtn_()" :disabled="info__.voteFlag" type="primary">投票<span
                                style="margin-left: 5px;">{{ info__.voteCount }}</span></el-button></div>
                    <div><el-button @click="shareBtn" type="dufault" icon="Share">分享</el-button>
                    </div>
                </div>


            </div>
            <div v-if="info__.content" style="font-size: 14px;color: #000;margin-top: 10px;">
                <div>
                    <span>视频简介</span>
                </div>
                <div style="margin-top: 10px;">
                    <span>{{ info__.content }}</span>
                </div>
            </div>
        </el-dialog>
        <el-dialog v-model="isShowShare_" modal-class="allProduction" :show-close="true" :close-on-click-modal="false"
            title="分享" width="500">
            <div class="" style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
                <div class="">
                    <canvas ref="qrcodeCanvas"></canvas>
                </div>
                <div class="" style=" color: #333333; font-size: 14px;">
                    扫描二维码，参与内容
                </div>

            </div>
            <div style="margin-top: 16px;">
                <div style=" color: #333333; font-size: 14px;">
                    <span>分享活动链接</span>
                </div>
                <div
                    style="border: 1px solid  #E5E6EB;border-radius: 8px;height: 45px;width: 100%;line-height: 45px;text-align: left;margin-top: 8px;color: #000000;padding-left: 12px;">
                    <span
                        style="display: inline-block; white-space: nowrap;overflow: hidden; text-overflow: ellipsis; width: 454px;">{{
                            fxxx }}</span>
                </div>
            </div>
            <div @click="copyBtn"
                style="background:#2978FF;border-radius: 12px;height: 45px;width: 100%;text-align: center;line-height: 45px;color: #FFF;margin-top: 8px;cursor: pointer;">
                <span>复制链接</span>
            </div>
        </el-dialog>
        <el-dialog v-model="voteBtnShow" modal-class="allProduction" :show-close="false" :close-on-click-modal="false"
            width="500">
            <template #header>
                <div
                    style="font-size: 18px;cursor: pointer;display: flex;align-items: center;column-gap: 15px;justify-content: flex-end;">
                    <el-icon @click.stop.prevent="voteBtnShow = false">
                        <CircleCloseFilled />
                    </el-icon>
                </div>
                <div style="display: flex;align-items: center;justify-content:center;">
                    <img src="../../assets/w1.png" />
                </div>
                <div style=" color: #333333; font-size: 13.33px; font-weight: 400;text-align: center;margin-top: 16px;">
                    <span>是否确认投票，投票后不可取消</span>
                </div>
                <div style=" color: #333333; font-size: 13.33px; font-weight: 400;text-align: center;margin-top: 5px;">
                    <span>您还有</span>
                    <span style="color: #cd4c32;">{{ voteRemainingNum }}</span>
                    <span>次投票机会</span>
                </div>
                <div
                    style="cursor: pointer; display:flex;align-items: center;justify-content: center;column-gap: 17px;margin-top: 16px;">
                    <div @click="voteBtnShow = false"
                        style="width: 73.33px;height: 31px;border: 0.83px solid var(---, #86909C);border-radius: 6.67px;text-align: center;line-height: 31px; color: #333333; font-size: 11.67px;">
                        <span>取消</span>
                    </div>
                    <div @click="voteBtn"
                        style="cursor: pointer;width: 73.33px;height: 31px;background:#2978FF;border-radius: 6.67px;text-align: center;line-height: 31px;  color: #ffffff; font-size: 11.67px;">
                        <span>确认</span>
                    </div>
                </div>
            </template>
        </el-dialog>

    </div>
</template>
<script setup lang="ts">
import { ref, nextTick } from 'vue';
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus"
import { useRoute, useRouter } from "vue-router";
const voteBtnShow = ref(false);
import getsignatureInfo from "../../wx/index.js";
import useClipboard from 'vue-clipboard3'
import img____ from "../../assets/fx.png"
import QRCode from 'qrcode'
import axios from "axios"
const isShowShare = ref(false);
const isShowShare_ = ref(false);
const router = useRouter();
const loading = ref(false);
const qrcodeCanvas = ref<any>(null)
const route = useRoute();
const { toClipboard } = useClipboard()
const userInfo: any = ref({});
const props_ = defineProps({
    data_monthly: { type: Array, default: () => { } },
    type: { type: String, default: "" },
})
const login_info = JSON.parse(localStorage.getItem("userList") as any);
const playerOptions = ref({
    autoplay: false,
    controls: true,
    muted: false,
    controlBar: {
        durationDisplay: true,
        volumePanel: {
            inline: false,
        },
    },
    sources: [
        {
            src: "",
            type: "video/mp4",
        },
    ],
});
const list: any = ref([]);
const queryParams = ref({
    pageNum: 1,
    pageSize: 12,
    total: 0
})
const activityType = ref("");
const getQrCode = function () {
    let a = location.origin + location.pathname + '?id=' + route.query.id + '&i=' + userInfo.value.memberId;
    let opts = {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 1,
        margin: 2,
        width: 200,
        height: 200,
        text: route.fullPath,
        color: {
            light: '#fff'
        }
    }
    QRCode.toCanvas(qrcodeCanvas.value, a, opts, function (error: any) { if (error) console.info(error) });
}

const shareBtn = () => {
    isShowShare_.value = true;
    nextTick(() => {
        getQrCode()
        if (!!qrcodeCanvas.value) {
            let ctx = qrcodeCanvas.value.getContext('2d')
            let image = new Image()
            image.crossOrigin = 'Anonymous'
            image.src = 'qrcodelogo.png'
            image.onload = () => {
                ctx.drawImage(image, 75, 75, 50, 50)
            }
        }
    })
}
const edit_click = defineEmits(["cancel"]);
const closeBtn = () => {
    getList('a')
    isShowShare.value = false;
    edit_click("cancel", false);
}
const getInfo = function () {
    Axios("get", "/system/activity/" + route.query.id, null, false, function (res: any) {
        if (res.data.code == 200) {
            activityType.value = res.data.data.activityType;
            getList();
        } else {
            ElMessage.error(res.data.message);
        }
    });
};
!props_.type && getInfo()
const ids: any = ref([]);
const idsfollow = () => {
    // member / member - follow / follow - ids
    Axios("GET", "/member/member-follow/follow-ids", null, false, function (res) {
        ids.value = res.data.data;
    });
}
let getInfo__ = function (id: any) {
    Axios(
        "GET",
        "/member/info/" + id,
        false,
        false,
        function (res: any) {
            idsfollow()
            userInfo.value = res.data.data;
        }
    );
};
const handleDelete = function () {
    Axios(
        "DELETE",
        "/member/member-follow",
        { memberId: userInfo.value.memberId },
        false,
        function (res: any) {
            ids.value = ids.value.filter((item: any) => item != userInfo.value.memberId);
            ElMessage({
                showClose: true,
                message: "已取消关注",
                type: "success",
            });
        }
    );
};
const toUser = () => {
    open("/ShadowComposerHomepage?id=" + userInfo.value.memberId, "_blank");
}
const CertificationCenter = () => {
    open("/AuthenTicationHome", "_blank");
};
const voteRemainingNum = ref(0);
const voteBtn_ = async (item?: any) => {
    if (localStorage.getItem("token") == null) {
        router.push({
            path: "/TgLogin",
            query: {
                url: location.href
            }
        });
        return
    }
    voteRemainingNum.value = 0;
    let res = await axios({
        url: `https://api.biaoshisx.com/system/activity/remainingNum?activityId=${route.query.id}`,
        method: "post",
        headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token") != null ? "Bearer " + localStorage.getItem("token") : "",
            "Access-Control-Allow-Origin": "*",
        }
    });
    if (res.data.code == 200) {
        res.data.data.remainingNum == 0 ? ElMessage.error('投票次数已用完') : (voteBtnShow.value = true);
        voteRemainingNum.value = res.data.data.remainingNum;
        item && Object.keys(item).length && (info__.value = item)
    } else {
        ElMessage.error(res.data.msg || '请求失败，请联系管理员');
    }

}
const copyBtn = async () => {
    await toClipboard(location.origin + location.pathname + '?id=' + route.query.id + '&i=' + userInfo.value.memberId);
    ElMessage.success("复制成功");
    isShowShare_.value = false
}
const voteBtn = async () => {
    let res = await axios({
        url: `https://api.biaoshisx.com/system/activity/voteFile?activityId=${route.query.id}&offlineFileId=${info__.value.id}`,
        method: "post",
        headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token") != null ? "Bearer " + localStorage.getItem("token") : "",
            "Access-Control-Allow-Origin": "*",
        }
    });
    if (res.data.code == 200) {
        info__.value.voteFlag = true;
        info__.value.voteCount = Number(info__.value.voteCount) + 1;
        ElMessage.success('投票成功');
        voteBtnShow.value = false;
        getList()
    } else {
        ElMessage.error(res.data.msg || '投票失败');
    }
}
const handleAdd = function () {
    Axios(
        "POST",
        "/member/member-follow",
        { memberId: userInfo.value.memberId },
        false,
        function (res: any) {
            ids.value = [...ids.value, userInfo.value.memberId];
            ElMessage({
                showClose: true,
                message: "关注成功",
                type: "success",
            });
        }
    );
};
const voteSwitch = ref(false);
const switchList = async () => {
    let res = await axios({
        url: `https://api.biaoshisx.com/system/activity/switch`,
        method: "post",
        headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token") != null ? "Bearer " + localStorage.getItem("token") : "",
            "Access-Control-Allow-Origin": "*",
        }
    });
    if (res.data.code == 200) {
        voteSwitch.value = res.data.data.switch == 'true' ? true : false;
    } else {
        voteSwitch.value = false;
    }
}
switchList()
const getList = async function (flag?: string) {
    let params = {
        pageNum: queryParams.value.pageNum,
        pageSize: queryParams.value.pageSize,
    };
    loading.value = true;
    let res = await axios({
        url: `https://api.biaoshisx.com/system/${activityType.value == '2' ? 'activity-join/offlineList' : 'activity-join/noticeFileList'}?activityId=${route.query.id}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
        method: "post",
        headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token") != null ? "Bearer " + localStorage.getItem("token") : "",
            "Access-Control-Allow-Origin": "*",
        }
    });
    if (res.data.code == 200) {
        if (res.data.rows.length) {
            if (activityType.value == '4') {
                list.value = res.data.rows;
                if (activityType.value == '4' && route.query.i && !flag) {
                    let filterItem = res.data.rows.filter((item: any) => {
                        return item.memberId == route.query.i
                    })
                    btn(filterItem[0])
                }

            } else {
                let s = res.data.rows[0].materialType == 'IMAGE' ? res.data.rows[0].imagesOther ? JSON.parse(res.data.rows[0].imagesOther).map(item => {
                    return {
                        showImage: item.url,
                        title: item.title,
                        type: "img"
                    }
                }) : [] : [res.data.rows[0]];
                list.value = s;
            }
            queryParams.value.total = res.data.total;
        }
    } else {
        ElMessage.error(res.data.msg || "查询失败");
    }
    loading.value = false;
};

const paginationChange = (num: number) => {
    queryParams.value.pageNum = num;
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
    getList()
}
const info__: any = ref({});
const fxxx = ref(location.href);
const btn = async (item: any) => {
    if (activityType.value == '4') {
        fxxx.value = location.origin + location.pathname;
        fxxx.value = fxxx.value + '?id=' + route.query.id + '&i=' + item.memberId;
        getsignatureInfo({
            url: encodeURIComponent(fxxx.value),
            title: item.fineFileTitle ? item.fineFileTitle : item.materialType == 'IMAGE' ? item.imagesOther ? JSON.parse(item.imagesOther)[0].title : '' : item.title,
            desc: item.content,
            imgUrl: item.avatar || img____
        })
        let res = await axios({
            url: `https://api.biaoshisx.com/system/activity/playCount?activityId=${route.query.id}&offlineFileId=${item.id}`,
            method: "post",
            headers: {
                Accept: "*/*",
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token") != null ? "Bearer " + localStorage.getItem("token") : "",
                "Access-Control-Allow-Origin": "*",
            }
        });
        if (res.data.code == 200) {
            getInfo__(item.memberId)
            info__.value = item;
            playerOptions.value.sources[0].src = item.previewPath;
            isShowShare.value = true;
        } else {
            ElMessage.error(res.data.msg || "查询失败");
        }
    } else {
        userInfo.value = JSON.parse(localStorage.getItem("userList") as any);
        info__.value = item;
        playerOptions.value.sources[0].src = item.previewPath;
        isShowShare.value = true;
    }
}
nextTick(() => {
    if (props_.type == 'no') {
        getInfo__((props_.data_monthly as any).memberId)
        info__.value = props_.data_monthly;
        playerOptions.value.sources[0].src = (props_.data_monthly as any).previewPath;
        isShowShare.value = true;
    }
})
</script>
<style>
.allProduction .el-dialog {
    border-radius: 12px;
    padding-bottom: 20px !important;
}
</style>
<style scoped lang="less">
/deep/video {
    object-fit: scale-down !important;
}

.wVC_list_l_T_B_rz {
    color: #015243;
    background: #e1fefc;
    border-radius: 0.1rem;
    font-size: 0.12rem;
    padding: 0.02rem 0.16rem 0.02rem 0.04rem;
    display: flex;
    align-items: center;
}

.wVC_list_l_T_B_rz>img {
    width: 0.13rem;
    margin-right: 0.09rem;
}

.BU_gz {
    background: #409eff;
    padding: 0.06rem 0.16rem;
    font-size: 0.12rem;
    color: #ffffff;
    border-radius: 0.04rem;
}

.container {
    width: 12rem;
    margin: 0 auto;
    padding-top: 0.4rem;
    background: var(--background);
    background-size: 100% 100%;
    padding: 10px;
}

/deep/.custom-video-player,
/deep/.video-js {
    width: 100% !important;
    height: 4.84rem !important;
    border-radius: 6px !important;
}

#allProduction {
    border-radius: 10px !important;
}

.body_left_video {
    height: 4.84rem;

    // background: #0f0;
}
</style>